"use client"

import Carousel from "@/components/common/Carousel"
import Link from "@/components/common/LinkNext"
import Text from "@/components/common/Typography/Text"
import Title from "@/components/common/Typography/Title"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { Col, Image, Row } from "antd"
import { useTranslation } from "react-i18next"

const ComboDeals = ({ data }: { data: any[] }) => {
  const comboData = data.reduce((arr, flashSale) => {
    return arr.concat(flashSale.items)
  }, [])
  const { t } = useTranslation()
  const isDesktop = useIsDesktop()

  return (
    <Row
      style={{ marginBottom: '3rem' }}
    >
      <Col span={24} style={{ marginBottom: '1rem' }}>
        <Row>
          <Title
            level={2}
            style={{
              margin: 0,
              marginBottom: '0.5rem'
            }}
          >
            {t("deals.combo_title")}
          </Title>
        </Row>
        <Row>
          <Text type='secondary'>
            {t("deals.combo_desc")}
          </Text>
        </Row>
      </Col>
      <Col span={24}>
        <Carousel
          options={{
            groupCells: true,
            contain: true
          }}
        >
          {comboData.map((combo: any, idx: number) => {
            if (!combo?.productMetaData?.banner) {
              return null
            }
            return (
              <Row
                key={combo?.id || combo?.productMetaData?.slug || idx}
                style={{ width: '100%' }}
              >
                <Col span={24}>
                  <Link
                    href={`/khach-san/${combo?.productMetaData?.slug}`}
                    target="_blank"
                    aria-label={combo?.productMetaData?.name ? `Combo ${combo.productMetaData.name}` : "Xem combo khách sạn"}
                    style={{ display: 'block', cursor: 'pointer' }}
                  >
                    <Image
                      preview={false}
                      src={combo?.productMetaData?.banner}
                      alt={combo?.productMetaData?.name ? `Combo ${combo.productMetaData.name}` : "Combo du lịch khách sạn giá tốt"}
                      width={"100%"}
                      height={!isDesktop ? "10rem" : "26rem"}
                      style={{ borderRadius: 8 }}
                    />
                  </Link>
                </Col>
              </Row>
            )
          })}
        </Carousel>
      </Col>
    </Row>
  )
}

export default ComboDeals